<template>
  <div class="c-target-rate">
    <div class="text">{{ label }} <span> {{ target }}</span></div>
    <div
      class="c-progress"
      :class="{
        'c-progress_lesszero': num < 0
      }"
      :style="{width}"
      v-if="isProgress"
    >
      <c-progress :height="height" :num="num"></c-progress>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    },
    isProgress: {
      type: Boolean,
      default: true
    },
    num: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '4rem'
    },
    height: {
      type: String,
      default: '.75rem'
    }
  }
}
</script>

<style lang="stylus" scoped>
.c-target-rate
  color rgba(255,255,255,.8)
  font-size .8rem
  line-height 2.2rem
  display flex
  flex-wrap nowrap
  white-space nowrap
  .text
    padding-right .25rem
.c-progress
  margin-top .725rem
  >>>.progress
    font-size .6rem
.c-progress_lesszero
  >>>.progress-bar
    background #362d78
</style>
